import { Tooltip, Space, Tag, Popconfirm, Switch, Flex, Typography } from "antd";
import get from "lodash/get";
import { EditTwoTone, DeleteTwoTone, SyncOutlined } from "@ant-design/icons";
import { COLOR_PRIMARY } from "../../constants";

const { Text } = Typography;

export const getTemplateTagColor = (val) => {
  switch (val) {
    case 1:
      return "geekblue";
    case 2:
      return "purple";
    case 3:
      return "volcano";
    case 4:
      return "magenta"
    default:
      return "purple";
  }
};

export const templateColumns = (toggleTemplateForm, onDeleteTempalte, toggleSyncForm, updatePauseStatus) => [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    render: (text, record) => {
      return (
        <>
          <Text>{text}</Text>
          {get(record, "syncing") && (
            <div>
              <Tag color="green" icon={<SyncOutlined spin />}>Syncing</Tag>
            </div>
          )}
        </>
      )
    }
  },
  {
    title: "Company",
    dataIndex: ["company", "name"],
    key: "company_name",
  },
  {
    title: "Reset Time",
    dataIndex: "reset_time",
    key: "reset_time",
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
    render: (type) => (
      <Tag color={getTemplateTagColor(get(type, "value"))}>
        <p className="text-center min-w-[120px]">

          {get(type, "name")}
        </p>
      </Tag>
    ),
  },
  {
    title: "Last Synced",
    dataIndex: "last_synced",
    key: "last_synced",
    render: (lastSynced) => <Tag>{lastSynced}</Tag>,
  },
  {
    title: "Pause",
    key: "status",
    dataIndex: "status",
    render: (status, record) => {
      return (
        <Flex justify="center" align="center">
          <Switch size="small" value={status} onChange={(value) => {
            updatePauseStatus(get(record, "id"), { status: value })
          }}
          checkedChildren={<Text className="text-white" style={{ fontSize: '10px' }}>Pause</Text>} 
          unCheckedChildren={<Text className="text-white" style={{ fontSize: '10px' }}>Resume</Text>}
          />
        </Flex>
      )
    }
  },
  {
    title: "Action",
    key: "status",
    render: (record) => {
      return (
        <Space size="middle">
          <Tooltip title="Edit Template">
            <EditTwoTone
              style={{ fontSize: 20 }}
              twoToneColor={COLOR_PRIMARY}
              onClick={() => {
                toggleTemplateForm(record, true);
              }}
            />
          </Tooltip>

          <Tooltip title="Delete Template">
            <Popconfirm
              title="Delete the Template"
              description="Are you sure to delete this template?"
              onConfirm={() => {
                onDeleteTempalte(get(record, "id"));
              }}
              okText="Yes"
              cancelText="No"
            >
              <DeleteTwoTone
                style={{ fontSize: 20 }}
                twoToneColor={COLOR_PRIMARY}
              />
            </Popconfirm>
          </Tooltip>

          <Tooltip title="Resync Template">
            <SyncOutlined
              onClick={() => {
                toggleSyncForm(record);
              }}
              style={{ fontSize: 20, color: COLOR_PRIMARY }}
              twoToneColor={COLOR_PRIMARY}
            />
          </Tooltip>

        </Space>
      );
    },
  },
];
